import PropTypes from 'prop-types';

import SideMsg from '#/modules/commonComponents/SideMsg';
import {
  salesOrderSideMsgDetailBlock,
  salesOrderSideMsgStatusBlock,
} from '#/modules/crmMgmt/salesOrder/data/salesOrderSideMsgConfig';

const SalesOrderSideMsg = ({ displayData }) => {
  const blocks = [
    salesOrderSideMsgStatusBlock,
    salesOrderSideMsgDetailBlock,
  ];

  return (
    <SideMsg
      title="銷貨單"
      titleValue="salesOrderNo"
      displayData={displayData}
      blocks={blocks}
    />
  );
};

SalesOrderSideMsg.propTypes = {
  displayData: PropTypes.object,
};

export default SalesOrderSideMsg;
